import React, { useEffect, useMemo, useState } from "react";
import impresoraManager from "./ImpresoraManager";
const estadoConfig = {
  pendiente: { icono: "⏳", texto: "Pendiente" },
  imprimiendo: { icono: "🖨️", texto: "Imprimiendo" },
  error: { icono: "❌", texto: "Error" },
  impreso: { icono: "✅", texto: "Impreso" },
  cancelado: { icono: "🚫", texto: "Cancelado" },
};
function formatearFecha(fecha) {
  if (!fecha) {
    return "";
  }
  return new Date(fecha).toLocaleTimeString();
}
function obtenerNombreTrabajo(tarea) {
  if (!tarea) {
    return "Documento";
  }
  return tarea.nombre || (tarea.cocina ? "Comanda cocina" : "Ticket");
}
export default function ColaImpresion({
  compacta = false,
  mostrarHistorial = true,
}) {
  const [cola, setCola] = useState([]);
  const [historial, setHistorial] = useState([]);
  const [actual, setActual] = useState(null);
  const [impresoraConectada, setImpresoraConectada] = useState(false);
  const cargarEstado = () => {
    const estado = impresoraManager.obtenerEstado();
    setCola(estado.colaDetalle || []);
    setHistorial(estado.historialImpresion || []);
    setActual(estado.trabajoImprimiendo || null);
    setImpresoraConectada(Boolean(estado.impresoraConectada));
  };
  useEffect(() => {
    cargarEstado();
    const cancelarCola = impresoraManager.on("cola", (datos) => {
      setCola(datos.cola || []);
      setHistorial(datos.historial || []);
      setActual(datos.actual || null);
      setImpresoraConectada(Boolean(datos.impresoraConectada));
    });
    const cancelarEstado = impresoraManager.on("estado", (datos) => {
      setImpresoraConectada(Boolean(datos.impresoraConectada));
    });
    return () => {
      cancelarCola();
      cancelarEstado();
    };
  }, []);
  const pendientes = useMemo(() => {
    return cola.filter(
      (tarea) => tarea.estado === "pendiente" || tarea.estado === "error",
    );
  }, [cola]);
  const errores = useMemo(() => {
    return cola.filter((tarea) => tarea.estado === "error");
  }, [cola]);
  const reintentar = async (id) => {
    try {
      await impresoraManager.reintentarTrabajoImpresion(id);
    } catch (error) {
      console.error("Error reintentando impresión:", error);
    }
  };
  const cancelar = (id) => {
    impresoraManager.cancelarTrabajoImpresion(id);
  };
  if (compacta) {
    return (
      <div
        style={{
          //   display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "6px 8px",
          borderRadius: 8,
          background: "#f5f5f5",
        }}
      >
        <span>
          {pendientes.length} pendiente
          {pendientes.length === 1 ? "" : "s"}
        </span>
        {actual && <span> 🖨️ {obtenerNombreTrabajo(actual)} </span>}
      </div>
    );
  }
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 600,
        border: "1px solid #ddd",
        borderRadius: 12,
        background: "#fff",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      {/* CABECERA */}
      <div
        style={{
          padding: 16,
          borderBottom: "1px solid #eee",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>
            🖨️ Fila de impresión
          </div>
          <div style={{ fontSize: 13, color: "#666", marginTop: 4 }}>
            {pendientes.length} pendiente
            {pendientes.length === 1 ? "" : "s"}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 13,
          }}
        >
          <span> {impresoraConectada ? "🟢" : "🔴"} </span>
          <span>{impresoraConectada ? "Conectada" : "Desconectada"}</span>
        </div>
      </div>
      {/* IMPRESIÓN ACTUAL */}
      {actual && (
        <div
          style={{
            padding: 16,
            background: "#f5f9ff",
            borderBottom: "1px solid #eee",
          }}
        >
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: "#555",
              marginBottom: 8,
            }}
          >
            IMPRIMIENDO AHORA
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <div style={{ fontWeight: 700 }}>
                🖨️ {obtenerNombreTrabajo(actual)}
              </div>
              <div style={{ fontSize: 13, color: "#666", marginTop: 4 }}>
                Folio: {actual.folio}
              </div>
            </div>
            <div style={{ fontSize: 13, color: "#555" }}>
              Intento {actual.intentos || 1}
            </div>
          </div>
        </div>
      )}
      {/* PENDIENTES */}
      <div>
        <div
          style={{
            padding: "12px 16px",
            fontSize: 12,
            fontWeight: 700,
            color: "#666",
            borderBottom: "1px solid #eee",
          }}
        >
          PENDIENTES
        </div>
        {pendientes.length === 0 ? (
          <div style={{ padding: 24, textAlign: "center", color: "#888" }}>
            No hay documentos pendientes.
          </div>
        ) : (
          pendientes.map((tarea, index) => {
            const config = estadoConfig[tarea.estado] || estadoConfig.pendiente;
            return (
              <div
                key={tarea.id}
                style={{ padding: 14, borderBottom: "1px solid #eee" }}
              >
                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: 8,
                      background: "#f3f3f3",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {config.icono}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600 }}>
                      {obtenerNombreTrabajo(tarea)}
                    </div>
                    <div style={{ fontSize: 13, color: "#666", marginTop: 3 }}>
                      Folio: {tarea.folio}
                    </div>
                    <div style={{ fontSize: 12, color: "#999", marginTop: 3 }}>
                      Agregado: {formatearFecha(tarea.creada)}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 6 }}>
                    {tarea.estado === "error" && (
                      <button
                        type="button"
                        onClick={() => reintentar(tarea.id)}
                        style={{
                          border: 0,
                          borderRadius: 6,
                          padding: "7px 10px",
                          cursor: "pointer",
                        }}
                      >
                        Reintentar
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={() => cancelar(tarea.id)}
                      style={{
                        border: 0,
                        borderRadius: 6,
                        padding: "7px 10px",
                        cursor: "pointer",
                      }}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
                {tarea.error && (
                  <div
                    style={{
                      marginTop: 10,
                      padding: 10,
                      borderRadius: 6,
                      background: "#fff3f3",
                      fontSize: 12,
                      color: "#a00",
                    }}
                  >
                    {tarea.error.mensaje}
                  </div>
                )}
                {index < pendientes.length - 1 && (
                  <div style={{ marginTop: 8, fontSize: 11, color: "#999" }}>
                    Posición en la fila: {index + 1}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
      {/* HISTORIAL */}
      {mostrarHistorial && historial.length > 0 && (
        <div>
          <div
            style={{
              padding: "12px 16px",
              fontSize: 12,
              fontWeight: 700,
              color: "#666",
              borderTop: "1px solid #eee",
              borderBottom: "1px solid #eee",
            }}
          >
            ÚLTIMAS IMPRESIONES
          </div>
          {historial.slice(0, 10).map((tarea) => (
            <div
              key={tarea.id}
              style={{
                padding: 12,
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <span> {tarea.estado === "cancelado" ? "🚫" : "✅"} </span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 13 }}>
                  {obtenerNombreTrabajo(tarea)}
                </div>
                <div style={{ fontSize: 12, color: "#777" }}>
                  Folio: {tarea.folio}
                </div>
              </div>
              <div style={{ fontSize: 11, color: "#999" }}>
                {formatearFecha(tarea.fechaFin)}
              </div>
            </div>
          ))}
        </div>
      )}
      {/* ERRORES */}
      {errores.length > 0 && (
        <div
          style={{
            padding: 12,
            background: "#fff8f8",
            borderTop: "1px solid #eee",
            fontSize: 12,
            color: "#a00",
          }}
        >
          ⚠️ Hay {errores.length} documento {errores.length === 1 ? "" : "s"}
          que requieren atención.
        </div>
      )}
    </div>
  );
}
